const message = {
  confirm: "确定",
  cancel: "取消",
  reset: "重置",
};

export default message;
